import React from 'react';
import './AboutOwlQuote.scss';
import Owl from '../../UI/Graphics/Owl';
import { COLORS } from '../../../constants/colors';

/**
 * Renders the about page owl quote module
 * @param {string} quote
 * @param {string} attribute
 * @param {string} ctaText
 * @param {string} ctaLink
 * @returns {JSX.Element}
 * @constructor
 */
const AboutOwlQuote = ({ quote, attribute, ctaText, ctaLink }) => (
  <div className="c-about-owl-quote background-color-orange">
    <div className="c-about-owl-quote__owl-container">
      <Owl color={COLORS.white} />
    </div>
    <div className="c-about-owl-quote__inner">
      <div className="c-about-owl-quote__quotation h4-right-grotesk">
        <span>“</span>
      </div>
      <div className="c-about-owl-quote__quote h3-roobert color-black">
        <h3>{quote}</h3>
      </div>
      <div className="c-about-owl-quote__attribute eyebrow-1">
        <p>{attribute}</p>
      </div>
      {ctaText !== '' && (
        <div className="c-about-owl-quote__cta-container text-cta cta color-black">
          <a className="color-black" href={ctaLink} target="_self">
            {ctaText}
          </a>
        </div>
      )}
    </div>
  </div>
);

export default AboutOwlQuote;
